import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { LogoMark } from "../components/Logo";
import { Input } from "../components/ui/input";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian blueprint-grid flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-olive-deep bg-obsidian p-8 sm:p-10">
        <div className="flex items-center gap-3 mb-2">
          <LogoMark size={36} />
          <span className="font-stencil text-base text-foreground">OPERATION FIX-IT</span>
        </div>
        <p className="overline-tactical text-coyote mb-8">/// COMMAND ACCESS ONLY</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-[10px] tracking-[0.3em] text-coyote mb-2">EMAIL</label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none bg-obsidian border-olive-deep focus-visible:ring-khaki"
              data-testid="admin-login-email-input"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.3em] text-coyote mb-2">PASSWORD</label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none bg-obsidian border-olive-deep focus-visible:ring-khaki"
              data-testid="admin-login-password-input"
            />
          </div>
          {error && (
            <p className="text-xs text-alert border border-alert/40 bg-alert/10 px-3 py-2" data-testid="admin-login-error">
              !! {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="dogtag w-full bg-olive text-white font-bold text-sm tracking-[0.25em] py-3.5 hover:bg-khaki hover:text-obsidian transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "AUTHENTICATING..." : "[ ACCESS COMMAND ]"}
          </button>
        </form>
        <a href="/" className="block mt-6 text-[10px] tracking-[0.25em] text-coyote hover:text-khaki transition-colors duration-300" data-testid="admin-login-back-link">
          &lt;&lt; RETURN TO BASE
        </a>
      </div>
    </div>
  );
}
